/* eslint-disable @typescript-eslint/no-misused-promises */

import { useQuery } from "@tanstack/react-query";
import { localstorageKeys } from "config";

import { axios, getLocalStorageItem } from "utils";

import { queryKeys } from "./";

export const GetUserProfile: () => any = async () => {
  const url = "/auth/me";
  return await axios({ url });
};

export const useGetUserProfileQuery: () => any = () => {
  return useQuery([queryKeys.GET_USER_PROFILE], GetUserProfile, {
    enabled: Boolean(
      getLocalStorageItem(localstorageKeys.AUTH_TOKEN)?.accessToken
    ),
    onError: async (e: any) => {
      console.log("auth error", e);
      if (e?.response?.data === "jwt expired") {
        window.localStorage.clear();
        window.location.reload();
      }
    },
  });
};
